import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-admin-controls',
  templateUrl: './admin-controls.component.html',
  styleUrls: ['./admin-controls.component.scss']
})
export class AdminControlsComponent implements OnInit {

  users;
  admins: Array<String>;
  selectUsersToPromoteForm: FormGroup;
  fromDateForm: FormGroup;


  constructor(private afAuth: AngularFireAuth, private realtimeDB: AngularFireDatabase) { }

  ngOnInit() {
    this.getUsers();
    this.getAdmins();
    this.selectUsersToPromoteForm = new FormGroup({
      selectUsers: new FormControl()
    });
  }

  getUsers() {
    this.realtimeDB.list('participants/').valueChanges().subscribe(data => {
      let userList = new Array<Object>();
      Object.keys(data).forEach(userObject => {
        let nestedResponse = data[userObject];
        Object.keys(nestedResponse).forEach(result => {
          userList.push(nestedResponse[result].EMAIL);
        });
      });
      this.users = userList.sort();
    });
  }

  getAdmins() {
    this.realtimeDB.list('admins/').valueChanges().subscribe(data => {
      this.admins = data.sort() as Array<String>;
    });
  }

  promoteToAdmin() {
    let emailToPromote = this.selectUsersToPromoteForm.controls['selectUsers'].value;
    let adminRef = this.realtimeDB.database.ref().child('admins/');
    if (confirm('WARNING: This action will promote ' + emailToPromote + ' to admin status. This action cannot be undone without the action of a superuser. Do you wish to continue?')) {
      if (this.admins.includes(emailToPromote)) {
        alert("This user is already an admin.");
      } else {
        var postKey = adminRef.push().key;
        var postData = {
          email: emailToPromote,
        }
        adminRef.push( postData ,
          (error) => {
            if (error) {
              alert(error);
            } else {
              alert("This user has been promoted to admin. If this is a mistake or an admin needs to be removed, contact support.")
            }
          });
        /* 
        TODO: 
        1. Add user to admin email list in firebase
        2. Change checkAdmin() to check against firebase admin  email list
        3. Add email template to update HR with 
        */
      }
    }
  }


}
